export default "__VITE_ASSET__29c6ead3__"